<template>
  <v-card class="mb-2" v-on="$listeners">
    <v-card-title v-if="$slots.title">
    <slot name="title"></slot>
    </v-card-title>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: 'CardComponent'
}
</script>

<style scoped lang="scss">
.v-sheet.v-card {
  &:not(.v-sheet--outlined) {
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.16);
  }

  .v-card__title {
    color: #878787;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;

  }

    margin-top: 16px;
    margin-bottom: 16px;

    > .row {
      padding: 0 16px;

      > .col {
        padding-top: 8px;
        padding-bottom: 8px;
      }
    }
  }
</style>
